export enum IdentificationMeetingStatus {
  OPEN = 'OPEN',
  SCHEDULED = 'SCHEDULED',
}
